<!--站点一览列表-->
<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">平台公告</span>
      </div>
      <div class="right">
        <Button @click="$router.back()">返回</Button>
      </div>
    </div>
    <div class="list-box">
      <div
        class="item"
        v-for="(item, index) in data"
        :key="index"
        @click="onItemClick(item.id)"
      >
        <div>
          <div class="tit" style="color: red" v-if="item.is_first == 1">
            {{ item.title }}
          </div>
          <div class="tit" :class="{ read: item.is_read == 1 }" v-else>
            {{ item.title }}
          </div>
          <div class="bottom">
            <span>{{ $moment(item.create_time) }}</span>
          </div>
        </div>
        <div class="right">
            <!-- <Icon type="ios-eye" color="#aaa" size="26" />
            <span style="margin-left: 8px">{{ item.see }}</span> -->
            <span v-if="item.is_first == 1" style="color: red;">置顶</span>
            <div v-else>
              <span v-if="item.is_read==1" style="color: #aaaaaa;">已读</span>
              <span v-else style="color: #000;">未读</span>
            </div>
          </div>
      </div>
    </div>
    <div class="t-right" style="margin-top: 15px">
      <Page
        @on-change="pageChange"
        @on-page-size-change="sizeChange"
        :total="total"
        show-elevator
        show-sizer
        show-total
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    return {
      page: {
        p: 0,
        l: 10
      },
      data: [],
      total: 0
    }
  },
  methods: {
    sizeChange (l) {
      this.page.l = l
      this.getData()
    },
    pageChange (p) {
      this.page.p = p - 1
      this.getData()
    },
    getData () {
      this.tableLoading = true
      this.GetNoticeList(this.page).then((res) => {
        this.total = res.data.total
        this.data = res.data.list
        this.tableLoading = false
      })
    },
    onItemClick (id = 0) {
      this.$router.push({ path: '/notice/info', query: { id } })
    },
    ...mapActions(['GetNoticeList'])
  },
  mounted () {
    this.getData()
  },
  computed: mapGetters({
    user: 'agent',
    access: 'access'
  })
}
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
